/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from "react";
import { Field, ErrorMessage, FieldProps, useFormikContext } from "formik";
import { Input, FormGroup } from "reactstrap";
import Select from "react-select";
import Flags from "react-world-flags";
import InputLabel from "@mui/material/InputLabel";
import { get } from "lodash";
import "./phone-number-component.scss";
import { PhoneNumberComponentProps } from "./phone-number-component-props";

const countryCodes = [
  { code: "+1", flag: "US" }, // United States
  { code: "+91", flag: "IN" }, // India
  { code: "+44", flag: "GB" }, // United Kingdom
];
const preventScroll = (e: Event) => {
  e.preventDefault();
};

const PhoneNumberComponent: React.FC<PhoneNumberComponentProps> = ({
  label,
  fieldName,
  countryCodeFieldName,
  placeholder,
  optional = true,
  isSearchable,
}) => {
  const { setFieldValue, setFieldTouched } = useFormikContext<{
    [key: string]: any;
  }>();
  const handlePhoneNumberInput = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    let digitsOnly = event.target.value.replace(/\D/g, "");

    if (digitsOnly.length > 10) {
      digitsOnly = digitsOnly.slice(0, 10);
    }
    setFieldValue(fieldName, digitsOnly);
  };

  const customCountryCodeOptions = countryCodes.map((item) => ({
    value: item.code,
    label: (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Flags
          code={item.flag}
          style={{ width: 20, height: 14, marginRight: 8 }}
        />
        {item.code}
      </div>
    ),
  }));

  return (
    <FormGroup className="phone-number-form-group">
      <InputLabel required={optional} htmlFor={fieldName}>
        {label}
      </InputLabel>
      <div className="custom-form-group-row">
        <div className="custom-form-group-col-select">
          <Field name={countryCodeFieldName}>
            {({ form }: FieldProps) => {
              const countryCodeValue = get(form.values, countryCodeFieldName);
              return (
                <Select
                  options={customCountryCodeOptions}
                  className="custom-country-code-dropdown"
                  classNamePrefix="custom-country-code-dropdown"
                  onMenuClose={() => {
                    setFieldTouched(countryCodeFieldName, true);
                  }}
                  onChange={(selectedOption: any) => {
                    setFieldValue(countryCodeFieldName, selectedOption?.value);
                  }}
                  menuPosition={"fixed"}
                  value={customCountryCodeOptions.find(
                    (option) => option.value === countryCodeValue
                  )}
                  onMenuOpen={() => {
                    document.body.style.overflow = "hidden";
                    document.addEventListener("touchmove", preventScroll, {
                      passive: false,
                    });
                  }}
                  isSearchable={isSearchable || false}
                />
              );
            }}
          </Field>
          <ErrorMessage
            name={countryCodeFieldName}
            component="div"
            className="error-message"
          />
        </div>
        <div className="custom-form-group-col">
          <Field name={fieldName}>
            {({ field }: FieldProps) => (
              <Input
                {...field}
                type="text"
                id={fieldName}
                placeholder={placeholder}
                className="custom-phone-input form-control"
                onChange={handlePhoneNumberInput}
              />
            )}
          </Field>
          <ErrorMessage
            name={fieldName}
            component="div"
            className="error-message"
          />
        </div>
      </div>
    </FormGroup>
  );
};

export default PhoneNumberComponent;
